const NC_PRIVILEGE = [
  { value: 0, text: 'Contact only' },
  { value: 1, text: 'Can schedule deliveries' },
  { value: 2, text: 'Full decision making' }
];

type NC_PRIVILEGE = typeof NC_PRIVILEGE;

export default NC_PRIVILEGE;
